import(/* webpackChunkName: "videoNumbersCheck" */ '../../Styles/TeaserVideoNumbersCheck/videoNumbersCheck.scss');

await import(/* webpackChunkName: "ajax" */ 'Feature/Common/code/Scripts/Common/ajax');

window.am = window.am || {};

window.am.lotteryVideoNumber = new function ()
{
    var that = this;

    that.init = function ()
    {
        var lotteryComponents = document.querySelectorAll(".videoNumbers-check-container");

        if (lotteryComponents == null)
        {
            return;
        }

        for (let i = 0; i < lotteryComponents.length; i++)
        {
            let inputText = lotteryComponents[i].querySelector(".numbers-check-input-text-number");
            let customErrorMessage = lotteryComponents[i].querySelector(".numbers-check-error-message");
            let checkNumberForm = lotteryComponents[i].querySelector(".numbers-check-form");
            let inputButton = lotteryComponents[i].querySelector(".input-button");
            let videoBox = lotteryComponents[i].querySelector(".video-box");
            let videoTextBoxButton = lotteryComponents[i].querySelector(".video-text-box-button");

            if (videoBox)
            {
                videoBox.addEventListener('click', function ()
                {
                    videoTextBoxButton.click();
                });
            } 

            document.addEventListener('click', function ()
            {
                if (customErrorMessage.classList.contains("error-active"))
                {
                    var errorMessageContent = customErrorMessage.querySelector('.message-content');
                    errorMessageContent.innerHTML = "";
                    customErrorMessage.classList.remove("error-active");
                }    
            });

            inputText.addEventListener('focus', function ()
            {
                let inputLabel = lotteryComponents[i].querySelector('.input-label');
                inputLabel.style.fontWeight = "bold";

            });

            inputText.addEventListener('blur', function ()
            {
                let inputLabel = lotteryComponents[i].querySelector('.input-label');
                inputLabel.style.fontWeight = "normal";
            });

            inputText.addEventListener('keypress', function (e)
            {
                if (customErrorMessage.classList.contains("error-active"))
                {
                    customErrorMessage.classList.remove("error-active");
                }

                var charCode = (e.which) ? e.which : e.keyCode

                //Key Code 31: with && charcode prevent to write !"§$ ect., Key Code 48 = 0 , Key Code 57 = 9 , Key Code 32 = space
                if (charCode > 31 && (charCode < 48 || charCode > 57) || charCode == 32)
                {
                    e.preventDefault();
                    return false;
                }

                if (e.keyCode !== 8)
                {
                    var inputTextWithoutSpaces = inputText.value.replace(/\s/g, '');
                    var chuncks = inputTextWithoutSpaces.match(/.{1,3}/g);

                    if (chuncks != null)
                    {
                        var outputText = chuncks.join(" ");
                        inputText.value = outputText;
                    }
                    else
                    {
                        inputText.value = inputTextWithoutSpaces;
                    }
                }
            });

            inputText.addEventListener('keyup', function (e)
            {
                let cursorPosition = inputText.selectionStart + 1;
                let isEdit = inputText.selectionStart !== inputText.value.length;
                let code = e.keyCode;

                //key code: 8 -> backspace, 37 -> left arrow, 38 -> up arrow, 39 - > right arrow, 40 -> bottom arrow
                if (code === 8 || code === 37 || code === 38 || code === 39 || code === 40 || isEdit) {
                        cursorPosition = cursorPosition - 1;
                }

                if (e.keyCode === 8 && inputText.value.endsWith(" "))
                {
                    inputText.value = inputText.value.slice(0, -1);

                    if (inputText.value.endsWith(" "))
                    {
                        inputText.value = inputText.value.slice(0, -1);
                    }
                }

                var inputTextWithoutSpaces = inputText.value.replace(/\s/g, '');
                var chuncks = inputTextWithoutSpaces.match(/.{1,3}/g);

                if (chuncks != null)
                {
                    if (chuncks.length > 1)
                    {
                        var outputText = chuncks.join(" ");
                        inputText.value = outputText;
                    }
                    else if (chuncks.length == 1)
                    {
                        inputText.value = chuncks[0];
                    }
                }
                else
                {
                    inputText.value = inputTextWithoutSpaces;
                }

                inputText.setSelectionRange(cursorPosition, cursorPosition);
            });

            inputButton.addEventListener('click', function (e)
            {
                e.preventDefault();
                performSubmit(inputText, customErrorMessage);
            });

            checkNumberForm.addEventListener('submit', function (e)
            {
                e.preventDefault();
                performSubmit(inputText, customErrorMessage);                
            });
        }
    }    

    that.checkAppLinkDisplay = function (AppLinkDesktop, AppLinkMobile)
    {
        if (screen.width > 768)
        {
            AppLinkDesktop.classList.remove("hide");
            AppLinkMobile.classList.add("hide");
        }
        else
        {
            AppLinkMobile.classList.remove("hide");
            AppLinkDesktop.classList.add("hide");
        }
    }

    function performSubmit(inputText, customErrorMessage)
    {
        var inputTextWithoutSpaces = inputText.value.replace(/\s/g, '');

        var url = '/api/sitecore/RaffleTicketCheck/CheckNumber?numberToCheck=' + inputTextWithoutSpaces;

        var successCallback = function (response)
        {
            if (!response.Error)
            {
                var dataSuccessAttribute = document.querySelector('[data-lottery-success-link]');

                var successUrl = dataSuccessAttribute.dataset.lotterySuccessLink + inputTextWithoutSpaces;
                window.location = successUrl;
            }
            else
            {
                customErrorMessage.classList.add("error-active");
                customErrorMessage.classList.add("error");

                var errorMessageContent = customErrorMessage.querySelector('.message-content');                
                errorMessageContent.innerHTML = response.ErrorMessage;
            }
        };

        window.am.ajax.sendRequest(url, "GET", successCallback);
    }
}

window.am.lotteryVideoNumber.init()